import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useSearchParams } from "react-router-dom";

export const ROUTES = {
  HOME: "/",

  SUPPORT: "/support",
  FEEDBACK_FORM: "/feedbackform",
  RESPONSE: "/response",
  Error404: "/error/Error404",
};

const App = () => {
  const { i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const language = searchParams.get("lang") || "en";
    i18n.changeLanguage(language);
  }, [i18n.language]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default App;
